/**
 * Bug Report Types
 *
 * Shared types + Zod schemas for the in-app bug reporter
 * (machina_bug_reports). Writes flow through the tRPC API only
 * (service-role); the browser never touches the table directly.
 */
import { z } from 'zod';
// =============================================================================
// UNIONS
// =============================================================================
export const BUG_REPORT_STATUSES = [
    'open',
    'in_progress',
    'resolved',
    'closed',
    'wontfix',
];
export const BUG_REPORT_PRIORITIES = [
    'low',
    'medium',
    'high',
    'critical',
];
// =============================================================================
// VALIDATION LIMITS
// =============================================================================
export const BUG_REPORT_TITLE_MAX = 200;
export const BUG_REPORT_DESCRIPTION_MAX = 5000;
/** Cap on the inline base64 screenshot data URL (~3MB of string). */
export const BUG_REPORT_SCREENSHOT_MAX = 3 * 1024 * 1024;
// =============================================================================
// CAPTURED CONSOLE LOG ENTRY
// =============================================================================
export const ConsoleLogEntrySchema = z.object({
    level: z.enum(['error', 'warn', 'log', 'info']),
    message: z.string(),
    timestamp: z.string(),
});
// =============================================================================
// SYSTEM INFO
// =============================================================================
export const BugSystemInfoSchema = z
    .object({
    browser: z.string().optional(),
    userAgent: z.string().optional(),
    route: z.string().optional(),
    screen: z.string().optional(),
    viewport: z.string().optional(),
    language: z.string().optional(),
    platform: z.string().optional(),
    timestamp: z.string().optional(),
})
    .passthrough();
// =============================================================================
// SUBMIT SCHEMA (client -> API input)
// =============================================================================
export const bugReportSubmitSchema = z.object({
    title: z.string().trim().min(1).max(BUG_REPORT_TITLE_MAX),
    description: z.string().max(BUG_REPORT_DESCRIPTION_MAX).optional(),
    consoleLogs: z.array(ConsoleLogEntrySchema).max(100).optional(),
    screenshotDataUrl: z.string().max(BUG_REPORT_SCREENSHOT_MAX).optional(),
    systemInfo: BugSystemInfoSchema.optional(),
    currentRoute: z.string().max(500).optional(),
    browserInfo: z.string().max(1000).optional(),
    screenSize: z.string().max(50).optional(),
    campaignId: z.string().uuid().optional(),
});
//# sourceMappingURL=bug-report-types.js.map